import type { JSX } from "react";
import { Navigate, Route, Routes } from "react-router";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Library from "./pages/Library";
import AssetDetail from "./pages/AssetDetail";
import Jobs from "./pages/Jobs";
import Overview from "./pages/Overview";
import { getToken } from "./lib/auth";

function RequireAuth({ children }: { children: JSX.Element }) {
  return getToken() ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route path="/" element={<Navigate to="/overview" replace />} />
        <Route path="/overview" element={<Overview />} />
        <Route path="/library" element={<Library />} />
        <Route path="/assets/:assetId" element={<AssetDetail />} />
        <Route path="/jobs" element={<Jobs />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
